export default __webpack_public_path__ + "static/media/standsExpo_acuityBrands.690361a5.jpg";